var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "linkedin icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.1-Vaitality-homes-page-Copy",
    transform: "translate(-1276.000000, -3599.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer",
    transform: "translate(0.000000, 3455.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "linkedin-icon",
    transform: "translate(1276.000000, 144.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2-Copy-3",
    fill: "#FFFFFF",
    cx: 22,
    cy: 22,
    r: 22
  }), /*#__PURE__*/React.createElement("g", {
    id: "linkedin-(1)",
    transform: "translate(10.000000, 11.000000)",
    fillRule: "nonzero",
    fill: "#006699"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "0 6.76923077 5.10714286 6.76923077 5.10714286 22 4.13293175e-17 22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.99651042,0 C1.18465375,0 0,1.096938 0,2.53872229 C0,3.94869867 1.14940068,5.07692308 2.9269469,5.07692308 L2.96144585,5.07692308 C4.8087441,5.07692308 5.95833333,3.94869867 5.95833333,2.53872229 C5.92383433,1.096938 4.8087441,0 2.99651042,0 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0548608,6.76923077 C15.3916937,6.76923077 14.1983776,8.21155646 13.5313353,9.22574396 L13.5313353,7.11850139 L8.51190476,7.11850139 L8.51190476,22 L13.5311567,22 L13.5311567,13.689507 C13.5311567,13.2446447 13.5638478,12.8004865 13.6963988,12.4823756 C14.0592169,11.5938833 14.8850703,10.673527 16.271675,10.673527 C18.0879093,10.673527 18.8144387,12.0382175 18.8144387,14.0387776 L18.8144387,22 L23.8333333,22 L23.8333333,13.4671639 C23.8333333,8.89619023 21.3570237,6.76923077 18.0548608,6.76923077 L18.0548608,6.76923077 Z",
    id: "Shape"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.b9e3b7bee3176093ca3aa25c10a30855.svg";
export { ForwardRef as ReactComponent };